// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-page-tsx": () => import("/Users/dsaewitz/y/gamehendge/src/templates/page.tsx" /* webpackChunkName: "component---src-templates-page-tsx" */),
  "component---src-pages-404-tsx": () => import("/Users/dsaewitz/y/gamehendge/src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("/Users/dsaewitz/y/gamehendge/src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

